import React from 'react'

import { Pill } from 'sdk/pill/Pill'
import { Text, TextName } from 'sdk/text/Text'

import type { SoundscapeCyberBuckCmsContent } from 'core/services/cms/interfaces'

import BookDemoCTA from './BookDemoCTA'
import CyberBuckShowcase from './CyberBuckShowcase'
import CyberBuckFeatureCards from './CyberBuckFeatureCards'

import styles from './CyberBuckSection.module.scss'

interface CyberBuckSectionProps {
  content: SoundscapeCyberBuckCmsContent
}

const CyberBuckSection: React.FC<CyberBuckSectionProps> = ({ content }) => {
  return (
    <section className={styles.container}>
      <div className={styles.title}>
        <Pill text={content.pillText} variant='gradient' />
        <Text type={TextName.H2}>{content.title}</Text>
      </div>
      <CyberBuckShowcase />
      <CyberBuckFeatureCards cards={content.featureCards} />
      <BookDemoCTA
        title={content.bookDemoTitle}
        buttonText={content.bookDemoButtonText}
        buttonUrl={content.bookDemoButtonUrl}
      />
    </section>
  )
}

export default CyberBuckSection
